import React from "react";
import './userSubhead.css';

export default () => (
  <span className="user_subheading">
    TECHNOLOGY CONSULTANT
  </span>
);


// WEBPACK FOOTER //
// ./src/components/userSubhead/userSubhead.js